import axios from 'axios';

//-------------------DEVELOPMENT(LOCAL)-------------------
// Frontend URL: http://localhost:3000 (or 192.168.1.9 / 127.0.0.1)
// const isLocal = true;
// const baseURL = 'http://localhost:8000/api';


// ------------------- DEVELOPMENT(OFFICE Server)-------------------
// Frontend URL: https://hariom.weborative.com
const isLocal = false;
const baseURL = 'https://apihariom.weborative.com/api';


//-------------------PRODUCTION(CLIENT Server)-------------------
// Frontend URL: https://pms.hariomelectricals.co.in
// const isLocal = false;
// const baseURL = 'https://srv.hariomelectricals.co.in/api';


const api = axios.create({
  baseURL: baseURL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
});

// Global loading state tracking
let loadingCount = 0;
let loadingCallback = null;

export const registerLoadingCallback = (callback) => {
  loadingCallback = callback;
  // Immediately notify of current state
  if (loadingCallback) {
    loadingCallback(loadingCount > 0);
  }
};

const notifyLoading = (isLoading) => {
  if (loadingCallback) {
    loadingCallback(isLoading);
  }
};

// Add a request interceptor to handle global loader
api.interceptors.request.use(
  (config) => {
    const url = config.url || '';
    const method = (config.method || '').toLowerCase();
    const perPage = Number(config.params?.per_page);

    const isDropdownEndpoint = method === 'get' && /-dropdown(?:\/|$|\?)/.test(url);
    const isLargeListUsedAsDropdown =
      method === 'get' &&
      perPage === 1000 &&
      /(\/projects|\/employees|\/vendors|\/customers|\/banks|\/taxes|\/units|\/countries|\/currencies|\/designations|\/departments)(?:\/|$|\?)/.test(url);

    if (isDropdownEndpoint || isLargeListUsedAsDropdown) {
      config.skipLoader = true;
    }

    if (!config.skipLoader) {
      loadingCount++;
      if (loadingCount === 1) notifyLoading(true);
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor to handle global loader
api.interceptors.response.use(
  (response) => {
    if (!response.config.skipLoader) {
      loadingCount = Math.max(0, loadingCount - 1);
      if (loadingCount === 0) notifyLoading(false);
    }
    return response;
  },
  (error) => {
    if (!error.config?.skipLoader) {
      loadingCount = Math.max(0, loadingCount - 1);
      if (loadingCount === 0) notifyLoading(false);
    }
    return Promise.reject(error);
  }
);

// Add a request interceptor to attach the auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

/**
 * Returns the base storage URL for accessing uploaded files.
 * Reads REACT_APP_STORAGE_URL from env, otherwise strips /api from the API base URL.
 * Usage: getStorageUrl('purchase-orders/file.jpg')
 */
export const getStorageUrl = (path) => {
  if (!path) return '';

  const base = baseURL.replace(/\/api$/, '');

  const cleanPath = path.toString()
    .replace(/^\/+/, '')
    .replace(/^public\//, '');

  return `${base}/storage/${cleanPath}`;
};

// Add a response interceptor to handle errors globally
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const status = error?.response?.status;
    const method = (error?.config?.method || '').toLowerCase();
    const url = error?.config?.url || '';
    const perPage = Number(error?.config?.params?.per_page);

    const isDropdownEndpoint = method === 'get' && /-dropdown(?:\/|$|\?)/.test(url);
    const isLargeListUsedAsDropdown =
      method === 'get' &&
      perPage === 1000 &&
      /(\/projects|\/employees|\/vendors|\/customers|\/banks|\/taxes|\/units|\/countries|\/currencies|\/designations|\/departments)(?:\/|$|\?)/.test(url);

    // Keep dropdowns resilient: if one endpoint is forbidden/not found, return empty options
    // so combined requests (e.g., Promise.all) can still resolve and render other dropdowns.
    if ((status === 403 || status === 404) && (isDropdownEndpoint || isLargeListUsedAsDropdown)) {
      return Promise.resolve({
        data: isLargeListUsedAsDropdown
          ? { success: true, data: { data: [] } }
          : { success: true, data: [] },
        status: 200,
        statusText: 'OK',
        headers: error?.response?.headers || {},
        config: error?.config,
        request: error?.request
      });
    }

    // If the error is 401 (Unauthorized), it means the token is invalid or expired
    if (error.response && error.response.status === 401) {
      // CLEAR ALL DATA to ensure no session info remains
      localStorage.clear();

      // Force redirect to login if not already there
      if (!window.location.pathname.includes('/login')) {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
